export function crocodileSearch(str: string, substr: string) {
  if (!str?.length || !substr?.length) {
    return false;
  }

  const original = str?.toLowerCase();
  const substring = substr?.toLowerCase();

  let counter = 0;

  for (let i = 0; i < original.length; i++) {
    if (original[i] === substring[counter]) {
      counter++;
    }
  }

  return substring.length === counter;
}
